/**
 * @Author: Zero
 * @Date: 2023-03-02 18:58:05
 * @Explain: 域名验证
 */

import http from '../http';
import httpv2 from '../http-v2';

const MODEL = '/domain';

export default {
  // 列表
  getList(data: Record<any, any>) {
    return httpv2.post(
      `${MODEL}/list_domain`,
      {},
      { params: { isPackage: 'N', switchReqToUnderline: true } },
    );
  },
  // // // 添加
  // // onAdd(data: Record<any, any>) {
  // //   return http.post(`${MODEL}/add`, data);
  // // },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/delete_domain`, data, {
      params: { isPackage: 'N' },
    });
  },
  // // 提交验证
  // onSubVerification(data: Record<any, any>) {
  //   return http.post(`/check/check-url`, data);
  // },
  // // 获取验证列表
  // getVerificationList(data: Record<any, any>) {
  //   return http.post(`/check/get-list`, data);
  // },

  // 查询域名是否占用
  queryDomain(data: Record<any, any>) {
    return http.post(`${MODEL}/query_domain`, data, {
      params: { isPackage: 'N' },
    });
  },
  // 添加域名验证
  verifyDomain(data: Record<any, any>, unUseCommonMsg?: boolean) {
    return http.post(`${MODEL}/veirfy_domain_v2`, data, {
      params: {
        // 是否弹出error提示框拦截
        unUseCommonMsg,
        // 处理请求参数标识信息
        isPackage: 'N',
        // 驼峰&下划线转换
        switchReqToUnderline: true,
      },
    });
  },
  // 检查spf,dkim 是否配置
  verifyIdentity(data: Record<any, any>) {
    return http.post(`${MODEL}/verify_identity_v2`, data, {
      params: { isPackage: 'N', switchReqToUnderline: true },
    });
  },
  // 回调地址配置
  eventNotify(data: Record<any, any>) {
    return http.post(`${MODEL}/event_notify`, data, {
      params: { isPackage: 'N' },
    });
  },
  // 移除沙盒校验
  sandboxCheck(data: Record<any, any>) {
    return http.post(`${MODEL}/sandbox_check`, data, {
      params: { isPackage: 'N' },
    });
  },
  // 导出域名的配置信息
  exportDomainConfig(data: Record<any, any>) {
    return http.post(`${MODEL}/export_msg`, data, {
      responseType: 'blob',
      params: { isPackage: 'N' },
    });
  },
};
